import { useForm } from "../../../provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import { emailDefault, requiredValidator } from "../../../services/validationRules";
import EmailCheck from "../../EmailCheck/EmailCheck";
import ButtonLoading from "../../Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "./ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React, { ReactElement } from "react";
import checkInFormBaseStyle from "./checkInFormBaseStyle";

type CheckInFormBaseProps = {
  formFields: ReactElement;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  isLoading: boolean;
};

export default function CheckInFormBase({ formFields, emailErrorText, setEmailErrorText, isLoading }: CheckInFormBaseProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "flex-start",
          justifyContent: "center"
        }}>
        <Grid
          sx={checkInFormBaseStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          {formFields}
        </Grid>
        <Grid
          sx={checkInFormBaseStyle.gridSpace}
          size={{
            xs: 12,
            sm: 4
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
          />
        </Grid>
        <Grid
          sx={[checkInFormBaseStyle.submit, checkInFormBaseStyle.gridTopSpaced]}
          size={{
            xs: 12,
            sm: 4
          }}>
          <ButtonLoading variant="contained" color="primary" sx={checkInFormBaseStyle.button} type="submit" fullWidth isLoading={isLoading}>
            jetzt starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
